import comp from "./UILabel";
export default comp;
